export { default as Home } from "./Home"
export { default as ClientLogin } from "./ClientLogin"
export { default as Contact } from "./Contact"
export { default as DevelopersApi } from "./DevelopersApi"
export { default as Solutions } from "./Solutions"
export { default as ApiDoc } from "./ApiDoc"
export { default as WhoWeAre } from "./WhoWeAre"
export { default as BlogPage } from "./BlogPage"
export { default as BlogDetailsPage } from "./BlogDetailsPage"
